import React from 'react';
import Message from '../../components/Message';

// interface Props {
//   // logOut: () => any;
// }

const LogoutView = () => (
  <div className="" data-testid="cmp-logout-view">
    <Message />
    {/* <Button value="Salir" icon="log-in" onClick={logOut} /> */}
  </div>
);

export default LogoutView;
